import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Resolves the Hyper3D material setting from the run's materialMode attribute.
 * Hyper3D's 'PBR' and 'ALL' both bring textures back, so they map to PBR;
 * 'shaded' (and any unknown value) falls back to BASIC.
 *
 * @param {string} [materialMode] - Hyper3D materialMode value
 * @returns {string} - One of MATERIAL.PBR | MATERIAL.BASIC
 */
export const deriveMaterialForHyper3d = (materialMode) => {
  const value = (materialMode ?? '').toString().toLowerCase()

  if (value.toLowerCase() === 'pbr' || value.toLowerCase() === 'all') {
    return MATERIAL.PBR
  }

  return MATERIAL.BASIC
}
